<!-- 添加客户车辆弹窗 -->
<template>
  <Dialog :visible="visible" position="bottom" @update:visible="e => { visible = e }">
    <div class="add-base-car-dialog">
      <div class="add-base-car-dialog-title">请添加车主车辆信息</div>
      <div class="add-base-car-dialog-content">
        <x-input
          v-model="formData.plate_number"
          placeholder="请填写车牌号"
          :max="10"
        />
        <x-input
          v-model="formData.vin"
          placeholder="请填写车架号（必填）"
          :max="17"
        />
        <x-input
          v-model="formData.model_desc"
          placeholder="请填写车型"
          :max="30"
        />
      </div>
      <div>
        <x-button type="primary" :disabled="submitDisabled || loading" @click="submit">添加车辆</x-button>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog/Index.vue'
import { XButton, XInput } from '@lx-frontend/cvux'
import { mapState } from 'vuex'
import util from '@/common/util'

export default {
  name: 'AddBaseCarDialog',
  components: {
    Dialog, XButton, XInput
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        plate_number: '',
        vin: '',
        model_desc: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.aftersales.userInfo
    }),
    submitDisabled() {
      return !this.formData.vin || this.formData.vin.length < 17
    }
  },
  mounted() {
  },
  methods: {
    open() {
      this.visible = true
      this.loading = false
      this.formData = {
        plate_number: '',
        vin: '',
        model_desc: ''
      }
    },
    close() {
      this.visible = false
    },
    async submit() {
      if (this.loading) return
      try {
        this.loading = true
        if (
          this.formData.plate_number &&
          !util.regexpMap.car_plate_number.test(this.formData.plate_number)
        ) return this.showToast('请输入有效的车牌号')

        if (
          !this.formData.vin ||
          !util.regexpMap.regexp_car_vin.test(this.formData.vin)
        ) return this.showToast('请输入有效的车架号')

        const params = { ...this.formData }

        const { code, message } = await this.$rest.aftersales.addBaseCar(this.userInfo.id)(params)
        if (code) return this.showToast(message)

        this.close()
        this.showToast('保存成功')
        this.$emit('success')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../stylesheets/base/fn.less';
@w2: 75rem;

.add-base-car-dialog {
  padding: 30/@w2;

  &-title {
    font-size: 34/@w2;
    line-height: 48/@w2;
    font-weight: 600;
    color: #1F2023;
    padding-bottom: 40/@w2;
  }

  &-content {
    display: flex;
    flex-direction: column;
    .gap-y(30/@w2);
    padding-bottom: 40/@w2;

    .vux-x-input {
      border-radius: 5/@w2;
      border: 1px solid #d9d9d9;
      padding: 20/@w2 30/@w2;
      font-size: 30/@w2;
      line-height: 2.26;

      &::before {
        border-top: 0;
      }
    }
  }

  /deep/ .weui_btn {
    height: 100/@w2;
    font-size: 30/@w2;
    border-radius: 5/@w2;

    &:disabled {
      opacity: 0.4;
    }
  }
}
</style>
